import { FC, useMemo } from 'react';

import { isNullish } from 'remeda';
import useSWR from 'swr';

import { options } from './constants';

import { ticketService } from 'v2/api/ticketService';
import { Select } from 'v2/components/select/Select';
import { TicketType, UserRewardType } from 'v2/constants';
import { SelectOption } from 'v2/types';

interface EntryRewardPickerProps {
  type: UserRewardType;
  onTypeChange: (value: UserRewardType) => void;
  value: string;
  onValueChange: (value: string) => void;
}

export const EntryRewardPicker: FC<EntryRewardPickerProps> = ({ type, onTypeChange, value, onValueChange }) => {
  const { data } = useSWR('getTickets', ticketService.getTickets);

  const filteredData = useMemo(() => {
    if (isNullish(data)) return [];

    return data.filter((ticket) => ticket.type === TicketType.CONTEST);
  }, [data, type]);

  const selectOptions: SelectOption[] = useMemo(() => {
    if (isNullish(filteredData)) return [];

    return filteredData.map((ticket) => ({ id: ticket.id, label: ticket.title, value: ticket.id }));
  }, [filteredData]);

  return (
    <div className="form-group">
      <Select value={type} options={options} label="Reward Type" onChange={onTypeChange} required />

      <Select value={value} options={selectOptions} label="Reward Value" onChange={onValueChange} required />
    </div>
  );
};
